import * as React from 'react';
import { Marker, MarkerProps } from '@react-google-maps/api';
import { mapDotIcon } from 'utils/mapsUtils';
import { useIsVisglMapsEnabled } from 'featureFlags/useIsVisglMapsEnabled';
import ConsumerLocationDotNew from 'components/maps/ConsumerLocationDotNew';

type Props = Exclude<MarkerProps, 'icon'>;

/**
 * Styled map marker indicating current location. Flag-forks between the legacy
 * `@react-google-maps/api` `<Marker>` and the vis.gl `<AdvancedMarker>` path.
 */
const ConsumerLocationDot: React.FunctionComponent<Props> = (props) => {
  const visglEnabled = useIsVisglMapsEnabled();
  const color1 = 'rgba(66,133,244,0.3)';
  const color2 = '#FFF';
  const color3 = 'rgba(66,133,244,1)';
  const dotSize = 40;

  // TODO(visgl-burn-in): remove this flag fork and the legacy `<Marker>` branch
  // below (keep ConsumerLocationDotNew) once CONSUMER_ENABLE_GOOGLE_MAPS_API_UPDATE
  // is fully rolled out.
  if (visglEnabled) {
    return <ConsumerLocationDotNew position={props.position as google.maps.LatLngLiteral} />;
  }

  return <Marker icon={mapDotIcon(dotSize, color1, color2, color3)} {...props} />;
};

export default ConsumerLocationDot;
